import { render, staticRenderFns } from "./UserLoader.vue?vue&type=template&id=6365ea1c&scoped=true&lang=html&"
import script from "./UserLoader.vue?vue&type=script&lang=js&"
export * from "./UserLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6365ea1c",
  null
  
)

export default component.exports